const AREA_23_WARDS_OF_TOKYO = '東京23区'
const AREA_TOKYO_OUTSIDE_23_WARDS = '東京23区外'
const AREA_KANAGAWA = '神奈川'
const AREA_CHIBA = '千葉'
const AREA_SAITAMA = '埼玉'

const GENRE_ITALIAN = 'イタリアン'
const GENRE_FRENCH = 'フレンチ'
const GENRE_IZAKAYA = '居酒屋'
const GENRE_CAFE = 'カフェ'
const GENRE_JAPANESE = '和食'
const GENRE_WESTERN = '洋食'
const GENRE_BAKERY = 'ベーカリー'
const GENRE_SUSHI = '寿司'
const GENRE_CHINESE = '中華'
const GENRE_HOTEL = 'ホテル・旅館'
const GENRE_BRIDAL = 'ブライダル'
const GENRE_MASS_CATERING = '集団調理'

const SHOP_STAFF = '店舗スタッフ'
const POSITION_KITCHEN_STAFF = 'キッチンスタッフ'
const POSITION_SUSHI_CHEF = '寿司職人'
const POSITION_NUTRITIONIST = '栄養士・管理栄養士'
const POSITION_FRONT_STAFF = 'フロントスタッフ'
const POSITION_SERVICE_STAFF = 'レストランサービススタッフ・ホールスタッフ'
const POSITION_FOOD_AND_BEVERAGE_STAFF = '料飲スタッフ'
const POSITION_HEAD_CHEF = '料理長・料理長候補'
const POSITION_MANAGER = '店長・店長候補'
const POSITION_PATISSIER = 'パティシエ'
const POSITION_BOULANGER = 'ブーランジェ・ベーカー'
const POSITION_SUPERVISOR = 'スーパーバイザー'
const POSITION_OTHER = 'その他(仕事内容)'

const FILTER_POSITION_SERVICE_STAFF = 'サービススタッフ'
const FILTER_POSITION_HEAD_CHEF = '料理長'
const FILTER_POSITION_MANAGER = '店長'
const FILTER_POSITION_BOULANGER = 'ブーランジェ'

export const zenkokuConfig = {
    jobs: [],
    filters: {
        area: [AREA_23_WARDS_OF_TOKYO, AREA_TOKYO_OUTSIDE_23_WARDS, AREA_KANAGAWA, AREA_CHIBA, AREA_SAITAMA],
        genre: [GENRE_ITALIAN, GENRE_FRENCH, GENRE_IZAKAYA, GENRE_CAFE, GENRE_JAPANESE, GENRE_WESTERN, GENRE_BAKERY, GENRE_SUSHI, GENRE_CHINESE, GENRE_HOTEL, GENRE_BRIDAL, GENRE_MASS_CATERING],
        position: [POSITION_KITCHEN_STAFF, FILTER_POSITION_SERVICE_STAFF, FILTER_POSITION_HEAD_CHEF, FILTER_POSITION_MANAGER, POSITION_PATISSIER, FILTER_POSITION_BOULANGER, POSITION_SUPERVISOR],
    },

    filtersList: {
        area: [
            {areaName: AREA_23_WARDS_OF_TOKYO, dataClickLabel: 'CT_Jobinformation_エリア-東京23区'},
            {areaName: AREA_TOKYO_OUTSIDE_23_WARDS, dataClickLabel: 'CT_Jobinformation_エリア-東京23区外'},
            {areaName: AREA_KANAGAWA, dataClickLabel: 'CT_Jobinformation_エリア-神奈川'},
            {areaName: AREA_CHIBA, dataClickLabel: 'CT_Jobinformation_エリア-千葉'},
            {areaName: AREA_SAITAMA, dataClickLabel: 'CT_Jobinformation_エリア-埼玉'}
        ],
        genre: [
            {genreName: GENRE_ITALIAN, dataClickLabel: 'CT_Jobinformation_料理ジャンル-イタリアン'},
            {genreName: GENRE_FRENCH, dataClickLabel: 'CT_Jobinformation_料理ジャンル-フレンチ'},
            {genreName: GENRE_IZAKAYA, dataClickLabel: 'CT_Jobinformation_料理ジャンル-居酒屋'},
            {genreName: GENRE_CAFE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-カフェ'},
            {genreName: GENRE_JAPANESE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-和食'},
            {genreName: GENRE_WESTERN, dataClickLabel: 'CT_Jobinformation_料理ジャンル-洋食'},
            {genreName: GENRE_BAKERY, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ベーカリー'},
            {genreName: GENRE_SUSHI, dataClickLabel: 'CT_Jobinformation_料理ジャンル-寿司'},
            {genreName: GENRE_CHINESE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-中華'},
            {genreName: GENRE_HOTEL, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ホテル旅館'},
            {genreName: GENRE_BRIDAL, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ブライダル'},
            {genreName: GENRE_MASS_CATERING, dataClickLabel: 'CT_Jobinformation_料理ジャンル-集団調理'}
        ],
        position: [
            {positionName: POSITION_KITCHEN_STAFF, dataClickLabel: 'CT_Jobinformation_職種-キッチンスタッフ'},
            {positionName: FILTER_POSITION_SERVICE_STAFF, dataClickLabel: 'CT_Jobinformation_職種-サービススタッフ'},
            {positionName: FILTER_POSITION_HEAD_CHEF, dataClickLabel: 'CT_Jobinformation_職種-料理長'},
            {positionName: FILTER_POSITION_MANAGER, dataClickLabel: 'CT_Jobinformation_職種-店長'},
            {positionName: POSITION_PATISSIER, dataClickLabel: 'CT_Jobinformation_職種-パティシエ'},
            {positionName: FILTER_POSITION_BOULANGER, dataClickLabel: 'CT_Jobinformation_職種-ブーランジェ'},
            {positionName: POSITION_SUPERVISOR, dataClickLabel: 'CT_Jobinformation_職種-スーパーバイザー'}
        ],
    },

    areaMapping: {},
    genreMapping: {},
    positionMapping: {},

    parameterMapping: {
        area: {
            '神奈川県': { city_id: 725 },
            '千葉県': { city_id: 596 },
            '埼玉県': { city_id: 531 },
        },
        genre: {
            [GENRE_ITALIAN]: { genre_id: 1 },
            [GENRE_FRENCH]: { genre_id: 2 },
            [GENRE_IZAKAYA]: { genre_id: 11 },
            [GENRE_CAFE]: { genre_id: 20 },
            [GENRE_JAPANESE]: { genre_id: 5 },
            [GENRE_WESTERN]: { genre_id: 4 },
            [GENRE_BAKERY]: { genre_id: 22 },
            [GENRE_SUSHI]: { genre_id: 7 },
            [GENRE_CHINESE]: { genre_id: 17 },
            [GENRE_HOTEL]: { genre_id: 23 },
            [GENRE_BRIDAL]: { genre_id: 25 },
            [GENRE_MASS_CATERING]: { genre_id: 24 },
        },
        position: {
            [POSITION_KITCHEN_STAFF]: { occupation_id: 4 },
            [POSITION_SERVICE_STAFF]: { occupation_id: 3 },
            [POSITION_HEAD_CHEF]: { occupation_id: 2 },
            [POSITION_MANAGER]: { occupation_id: 1 },
            [POSITION_PATISSIER]: { occupation_id: 11 },
            [POSITION_BOULANGER]: { occupation_id: 12 },
            [POSITION_SUPERVISOR]: { occupation_id: 19 }
        }
    },

    jobInformationData: {
        dataClickLabels: {
            area: 'CT_Jobinformation_エリア',
            genre: 'CT_Jobinformation_料理ジャンル',
            position: 'CT_Jobinformation_職種',
        }
    },

    faqData: [
        {
            id: 1,
            question: '本当にお金はかかりませんか？',
            answer: 'はい。弊社のサービスにつきまして、お金は一切かかりません。ご利用して頂いた求職者様の中には「面接を受けたら、入社したらお金が発生する」と思っている方もいらっしゃいますが、そういったこともございませんのでご安心くださいませ。ただし、面談や面接にお越しいただく際の交通費は実費でのご負担になりますのでご了承下さいませ。',
            dataClickLabel: 'CT_Question_Accordion-1st'
        },
        {
            id: 2,
            question: '在職中で、まだ転職を検討中ですが利用しても大丈夫ですか？',
            answer: 'もちろん大丈夫です。在職中の方からも多くご相談いただいておりまして、面接日も弊社が求職者様のスケジュールにあわせて調整していきます。入社日につきましても、現職先の退社日にあわせて、弊社が代わって転職先の企業様と調整いたします。',
            dataClickLabel: 'CT_Question_Accordion-2nd'
        },
        {
            id: 3,
            question: '全然時間がなくて、面談はそちらへ行かないとダメですか？',
            answer: '基本的にはご来社いただいて、面談でキャリアアドバイザーと直接お話しした方がスムーズに進めますが、現在ではテレビ電話のアプリを利用したWEB面談も実施しております。新型コロナウイルス感染症の一件もございますので、感染を懸念される方や時間が全くない方に関しましてはご予約の際に伝えていただけますと幸いです。',
            dataClickLabel: 'CT_Question_Accordion-3rd'
        },
        {
            id: 4,
            question: '早めに仕事がしたいのですが、どれくらいで転職できますか？',
            answer: '企業様のスケジュールにもよりますが、大体1～2週間くらいをみていただければと思います。しかし、ケースによっては面談した日に面接、その場で内定をいただいて入社！という最速１日で転職できることもありますので、担当のキャリアアドバイザーにご相談ください。',
            dataClickLabel: 'CT_Question_Accordion-4th'
        },
        {
            id: 5,
            question: '内定をいただいたところに必ず入社しないといけないのでしょうか？',
            answer: '必ず入社する必要はございません。企業への辞退連絡に関しても、弊社の方で対応しますので、ご安心ください。また、複数の企業を受けて内定をいくつかいただいていて迷われている場合も、担当のキャリアアドバイザーにご相談ください。',
            dataClickLabel: 'CT_Question_Accordion-5th'
        },
    ],
    footerData: {
        companyInfo: '株式会社クオレガ\nフーズラボエージェント\n〒105-0004東京都港区新橋1丁目10-6\n新橋M-SQUARE11階',
        licenseInfo: '厚生労働大臣許可番号有料職業紹介事業許可番号\n13-ユ-308506\n',
        dataClickLabels: {
            pageTop: 'FT_FooterArea_PageTop',
            termsOfService: 'FT_FooterArea_利用規約',
            privacyPolicy: 'FT_FooterArea_プライバシーポリシー'
        }
    },
    officeData: [
        {
            id: 1,
            name: 'tokyo',
            image: '/renewal_lp/Office/office_tokyo.png',
            alt: '東京本社 東京都港区新橋1丁目10-6新橋M-SQUARE11F',
            title: '東京本社',
            address: '東京都港区新橋1丁目10-6\n新橋M-SQUARE11F',
        },
        {
            id: 2,
            name: 'kansai',
            image: '/renewal_lp/Office/office_kansai.png',
            alt: '関西支社 大阪府大阪市北区梅田2丁目4-9ブリーゼタワー17F',
            title: '関西支社',
            address: '大阪府大阪市北区梅田2丁目4-9\nブリーゼタワー17F',
        },
        {
            id: 3,
            name: 'nagoya',
            image: '/renewal_lp/Office/office_nagoya.png',
            alt: '名古屋支社 愛知県名古屋市中村区名駅3丁目28-12大名古屋ビルヂング11階',
            title: '名古屋支社',
            address: '愛知県名古屋市中村区名駅3丁目28-12\n大名古屋ビルヂング11階',
        },
        {
            id: 4,
            name: 'fukuoka',
            image: '/renewal_lp/Office/office_fukuoka.png',
            alt: '福岡支社 福岡県福岡市中央区天神1丁目13-17福岡天神1丁目ビル7階',
            title: '福岡支社',
            address: '福岡県福岡市中央区天神1丁目13-17\n福岡天神1丁目ビル7階',
        },
        {
            id: 5,
            name: 'sapporo',
            image: '/renewal_lp/Office/office_sapporo.png',
            alt: '札幌支社 北海道札幌市中央区南1条西5丁目20郵政福祉札幌第一ビル4階',
            title: '札幌支社',
            address: '北海道札幌市中央区南1条西5丁目20\n郵政福祉札幌第一ビル4階',
        },
    ],
    stepFormLabels: {
        step0: {
            dataViewLabel: 'EF_StepForm_Step0-転職意欲',
            dataClickLabels: {
                high: 'EF_StepForm_Step0-転職意欲-転職したい',
                moderate: 'EF_StepForm_Step0-転職意欲-情報収集',
                close: 'EF_StepForm_Step0-閉じる',
                blank: 'EF_StepForm_Step0-空白',
            }
        },
        step1: {
            dataViewLabel: 'EF_StepForm_Step1-現在の状況',
            dataClickLabels: {
                working: 'EF_StepForm_Step1-現在の状況-在籍中',
                unemployed: 'EF_StepForm_Step1-現在の状況-離職中',
            }
        },
        step2: {
            dataViewLabel: 'EF_StepForm_Step2-経験年数',
            dataClickLabels: {
                lessThan1: 'EF_StepForm_Step2-経験年数-1年未満',
                oneToFive: 'EF_StepForm_Step2-経験年数-1~5年',
                fiveToTen: 'EF_StepForm_Step2-経験年数-5~10年',
                moreThan10: 'EF_StepForm_Step2-経験年数-10年以上',
                back: 'EF_StepForm_Step2-経験年数-戻る'
            }
        },
        step3: {
            dataViewLabel: 'EF_StepForm_Step3-お住まい',
            dataClickLabels: {
                back: 'EF_StepForm_Step3-お住まい-戻る',
                next: 'EF_StepForm_Step3-お住まい-次へ'
            }
        },
        step4: {
            dataViewLabel: 'EF_StepForm_Step4-名前年齢',
            dataClickLabels: {
                back: 'EF_StepForm_Step4-名前年齢-戻る',
                next: 'EF_StepForm_Step4-名前年齢-次へ'
            }
        },
        step5: {
            dataViewLabel: 'EF_StepForm_Step5-連絡先',
            dataClickLabels: {
                back: 'EF_StepForm_Step5-連絡先-戻る',
                link: 'EF_StepForm_Step5-連絡先-Link-利用規約',
                cta: 'EF_StepForm_Step5-連絡先-CVボタン',
                lineCheckbox: 'EF_StepForm_Step5-連絡先-LINEチェック'
            }
        },
    },
}